import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import 'leaflet/dist/leaflet.css';
import '@mantine/core/styles.css';
import 'mantine-datatable/styles.css';
import '@mantine/carousel/styles.css';
import '@mantine/notifications/styles.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import { Provider } from 'react-redux';
import '@mantine/tiptap/styles.css';
// import store from './redux/store';
import { persistor, store } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import '@mantine/core/styles.css';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { ModalsProvider } from '@mantine/modals';
import '@mantine/dates/styles.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>

    <React.StrictMode>
      <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <MantineProvider>
          <Notifications />
          <ModalsProvider>
            <PersistGate loading={null} persistor={persistor}>
              <App />
            </PersistGate>
          </ModalsProvider>
        </MantineProvider>
      </BrowserRouter>
    </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
